module.exports = __webpack_public_path__ + "img/드래곤샤먼.20d1a616.png";